



































import Vue from 'vue';
import gql from 'graphql-tag';
import { mapActions } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';

export default Vue.extend({
  name: 'DeleteCard',
  components: {
    GenericCard,
    BFormCheckbox,
  },
  props: {
    objects: {
      type: Array,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    queryToRefetch: {
      type: String,
      default: 'SorListingObjects',
    },
  },
  data() {
    return {
      loading: false,
      confirmed: false,
      objectTitle: 'an object',
    };
  },
  computed: {
    titleCopy(): string {
      if (this.objects.length > 1) {
        // TODO: Get proper plural object type
        return `${this.objects.length} ${this.objectType}s`;
      } else {
        return this.formatObjectTitle ? `"${this.objectTitle}"` : this.objectTitle;
      }
    },
    titleClass(): any[] {
      return ['obj-title', { 'font-italic': this.italicizeObjectTitle }];
    },
    italicizeObjectTitle(): boolean {
      return !!this.objectTitle;
    },
    formatObjectTitle(): boolean {
      return this.italicizeObjectTitle && this.objectTitle !== 'an object';
    },
  },
  created() {
    this.changeSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      changeSize: 'modals/changeSize',
      confirmModal: 'modals/confirm',
    }),
    async confirmDeletion() {
      try {
        // Disable confirmation button
        this.loading = true;
        const refetchQueries = [this.queryToRefetch];

        // TODO: check if all objects were deleted
        await this.$apollo.mutate({
          mutation: gql`
            mutation deleteObjects($ids: [ID]!) {
              deleteObjectsById(ids: $ids) {
                removedIds
              }
            }
          `,
          variables: {
            ids: this.objects,
          },
          // This seems the most reliable way to update table data
          refetchQueries,
        });
        this.confirmModal();
      } catch {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      } finally {
        this.loading = false;
      }
    },
  },
  apollo: {
    objectTitle: {
      skip() {
        return this.objects.length > 1;
      },
      query() {
        const type = this.objectType;
        return gql`
          query ObjectTitle($id: ID!) {
            node(id: $id) {
              ... on ${type} {
                title {
                  value
                }
              }
            }
          }
        `;
      },
      variables() {
        return {
          id: this.objects[0],
        };
      },
      update(data) {
        return data.node.title.value;
      },
      error() {
        this.objectTitle = 'an object';
      },
    },
  },
});
